import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Reservation } from '../_models/reservation';

@Injectable({
  providedIn: 'root'
})
export class ToursService {

  //***  para los tours con reserva  ********************************
  private idPaquete = new BehaviorSubject<Number>(new Number());
  paqueteReservado = this.idPaquete.asObservable()

  private idPaquetePasajero = new BehaviorSubject<Number>(new Number());
  paqueteReservadoPasajero = this.idPaquetePasajero.asObservable()

  private idPasajero = new BehaviorSubject<Number>(new Number());
  pasajeroReservado = this.idPasajero.asObservable()

  private idAgencia = new BehaviorSubject<Number>(new Number());
  agenciaReserva = this.idAgencia.asObservable()
  //*************************************************************


  //***  para los tours confirmados  ******************************

  private idPaqueteCnf = new BehaviorSubject<Number>(new Number());
  paqueteConfirmado = this.idPaqueteCnf.asObservable()

  private idAgenciaCnf = new BehaviorSubject<Number>(new Number());
  agenciaConfirmada = this.idAgenciaCnf.asObservable()

  private idPaqueteCnfPasajero = new BehaviorSubject<Number>(new Number());
  paqueteConfirmadoPasajero = this.idPaqueteCnfPasajero.asObservable()

  private idPasajeroCfm = new BehaviorSubject<Number>(new Number());
  pasajeroConfirmado = this.idPasajeroCfm.asObservable()
  //*************************************************************

  httpHeaders = new HttpHeaders({
  });
  constructor(private http: HttpClient) { }

  //***  para los tours con reserva  *******************************
  changePaqueteId(message: Number) {
    this.idPaquete.next(message);
  }

  changePaqueteIdPasajero(message: Number) {
    this.idPaquetePasajero.next(message);
  }

  changePasajeroId(message: Number) {
    this.idPasajero.next(message);
  }

  changeAgenciaId(message: Number) {
    this.idAgencia.next(message);
  }
  //*************************************************************



  //***  para los tours confirmados  **************************

  changePaqueteCnfId(message: Number) {
    this.idPaqueteCnf.next(message);
  }

  changeAgenciaCnfId(message: Number) {
    this.idAgenciaCnf.next(message);
  }

  changePaqueteIdPasajeroCnf(message: Number) {
    this.idPaqueteCnfPasajero.next(message);
  }

  changePasajeroCfmId(message: Number) {
    this.idPasajeroCfm.next(message);
  }
  //*************************************************************

  getAllToursByAgent(destino: string, fecha: string, ordenarPor: string) {
    const data: FormData = new FormData();
    data.append("destino", destino);
    data.append("fecha", fecha);
    data.append("ordenarPor", ordenarPor);

    return this.http
			.post<any>(environment.api + 'api/paquete/searchPaquetes',data,{
        headers: this.httpHeaders,
        reportProgress: true,
      });

  }

  getImageByType(idtour, imagenType) {
    return this.http
			.get<any>(environment.api + 'api/imagen/list?id_paquete='+idtour+'&tipo='+imagenType,{
        headers: this.httpHeaders,
        reportProgress: true,
      });

  }
  getTourDetail(idtour) {
    return this.http
			.get<any>(environment.api + 'api/paquete/get?id='+idtour,{
        headers: this.httpHeaders,
        reportProgress: true,
      });

  }
  getHotelByTour(idhotel) {
    return this.http
			.get<any>(environment.api + 'api/hotel/get?id='+idhotel,{
        headers: this.httpHeaders,
        reportProgress: true,
      });
  }
  getReservedSeats(idtour){
    return this.http
    .get<any>(environment.api + 'api/reservacion/getAsientosPaquete?id_paquete='+idtour,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }
  getExcursionByTour(idtour){
    return this.http
    .get<any>(environment.api + 'api/excursion/list?id_paquete='+idtour,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }
  getItineraryByTour(idtour){
    return this.http
    .get<any>(environment.api + 'api/itinerario/getItinerarioSlider?id_paquete='+idtour,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }

  getOpcionalExcursionByTour(idtour){
    return this.http
    .get<any>(environment.api + 'api/itinerario/getExcursionesSlider?id_paquete='+idtour,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }

  postReservation(reservation:Reservation) {
    return this.http
			.post<any>(environment.api + 'api/reservacion/create',reservation,{
        headers: this.httpHeaders,
        reportProgress: true,
      });
  }
  postPassenger(passangers) {
    return this.http
			.post<any>(environment.api + 'api/pasajero/createPasajeros',passangers,{
        headers: this.httpHeaders,
        reportProgress: true,
      });
  }

  getPasajeroByDni(dni) {
    return this.http
    .get<any>(environment.api + 'api/pasajero/getByDNI?dni='+dni,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }

  getReservacion(id){
    return this.http
    .get<any>(environment.api + 'api/reservacion/get?id='+id,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }
  getPasajeros(id){
    return this.http
    .get<any>(environment.api + 'api/pasajero/list?reservacion='+id,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
  }

  datosReservacion(idReservacion: String): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/get?id='+idReservacion, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }


}
